import TranslatedStyles from './translated_styles';

export {
  TranslatedStyles
};
